import React from 'react';

import { SidebarItems } from '@/modules/corporate/modules/admin/hooks/useSidebar';

import { UnifiedNav } from '../types';

export function toSidebarItems(nav: UnifiedNav): SidebarItems {
  return nav.map((section) => ({
    id: section.id,
    children: section.items.map((item) => {
      const Icon = item.icon;

      return {
        id: item.id,
        text: item.label,
        icon: Icon ? <Icon className="h-20 w-20" /> : undefined,
        to: item.href,
        enabled: true,
        isDisabled: item.isDisabled,
        children: item.groups?.flatMap((group) =>
          group.items.map((subItem) => {
            const SubIcon = subItem.icon;

            return {
              id: subItem.id,
              text: subItem.label,
              icon: SubIcon ? <SubIcon className="h-20 w-20" /> : undefined,
              to: subItem.href,
              enabled: true,
              isDisabled: subItem.isDisabled,
              groupId: group.id,
            };
          }),
        ),
      };
    }),
  }));
}
